import BannerToEnableTitanTrial from '@/components/Email/BannerToEnableTitanTrial';
import ModalTitanTrialColorful from '@/components/Email/ModalTitanTrialColorful';
import { executeGADisplayBannerFromDomains, executeWithParams } from '@/utils/ThirdParties/tagManager';
import React, { useCallback, useState } from 'react';

const TitanTrialBanner = ({ domainWithoutEmail, essentialData }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [enableTrialState, setEnableTrialState] = useState({
    modalIsOpen: false,
    isEnabledByURLParam: false,
    hideBanner: true,
    currentDomain: {
      id: null,
      domain: null,
    },
  });

  const domainWithoutEmailFormattedToOptions = domainWithoutEmail.map(item => ({ value: item.id, label: `@${item.domain}` }));

  const enableTrialByBannerGAEventsByAction = useCallback((action) => {
    executeWithParams(
      'gaEvent',
      'e-mail',
      'Banner trial de Titan - aba de Domínios',
      action,
    );
  }, []);

  const handleCloseModal = useCallback(
    () => {
      enableTrialByBannerGAEventsByAction('Fechar modal');

      setEnableTrialState(previousEnableTrialState => ({
        ...previousEnableTrialState,
        modalIsOpen: false,
        currentDomain: { id: null, domain: null },
      }));
    }, [setEnableTrialState, enableTrialByBannerGAEventsByAction],
  );

  const handlerChangeBannerSelect = useCallback(({ value, label }) => {
    enableTrialByBannerGAEventsByAction('Selecionar domínio');

    setEnableTrialState(previousEnableTrialState => ({
      ...previousEnableTrialState,
      modalIsOpen: true,
      currentDomain: { id: value, domain: label },
    }));
  }, [setEnableTrialState, enableTrialByBannerGAEventsByAction]);

  const onBannerLoaded = useCallback(() => {
    if (!isLoaded) {
      executeGADisplayBannerFromDomains();
      setIsLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ModalTitanTrialColorful
        isOpen={enableTrialState.modalIsOpen}
        isEnabledByURLParam={enableTrialState.isEnabledByURLParam}
        onClose={handleCloseModal}
        selectedDomain={enableTrialState.currentDomain}
        essentialData={essentialData}
        offerContext={['domain_page_banner_trial_activation']}
        location="modalDomainList"
      />
      <BannerToEnableTitanTrial
        domainOptions={domainWithoutEmailFormattedToOptions}
        onDomainSelected={handlerChangeBannerSelect}
        productName={essentialData.name}
        onBannerLoaded={onBannerLoaded}
      />
    </>
  );
};

export default TitanTrialBanner;
